import type { SlotRole } from '@revelio/core';

import type { SnowflakeConfigField } from '../../PageConfigProvider/types/item';

/**
 * Returns updated snowflake fields with the matching slotRole field's value updated.
 */
export function syncSlotValueToSnowflakeFields(
  fields: SnowflakeConfigField[],
  slotRole: SlotRole,
  value: string | number | string[] | number[]
): SnowflakeConfigField[] {
  return fields.map((f) => {
    if (f.slotRole === slotRole) {
      return { ...f, value: String(value) };
    }
    return f;
  });
}
